import * as log from "loglevel";
export { log };
export async function sleep(milliseconds) {
    return new Promise((f) => setTimeout(f, milliseconds));
}
